// import './client'
import './components';
import KrealabModal from "./elements/KrealabModal";
import KrealabAjaxForm from './elements/KrealabAjaxForm';

document.addEventListener('DOMContentLoaded', function() {
    let ldProjectTrigger = document.getElementById('lpContact-trigger');
    let ldProject = document.getElementById('lpContact');
    let ldClose = document.getElementById('lpContact-close');
    let ldWrapper = document.querySelector('.landing-page__contact-wrapper');
    let buttonContactTriggers = document.querySelectorAll('.button-contact-trigger');

    // Écouter l'événement de défilement
    window.addEventListener('scroll', function() {
        // Vérifier la position de défilement
        if (window.scrollY >= 500) {
            if(ldWrapper){
                ldWrapper.classList.add('visible');
            }
            
        } else {
            if(ldWrapper){
                ldWrapper.classList.remove('visible');
            }
        }
    });

    // Ajouter un événement click pour tous les boutons avec la classe "button-contact-trigger"
    buttonContactTriggers?.forEach(function(button) {
        button.addEventListener('click', function() {
            ldProject.classList.toggle('active');
        });
    });

    ldProjectTrigger?.addEventListener('click', function() {
        ldProject.classList.toggle('active');
    });

    ldClose?.addEventListener('click', function() {
        ldProject.classList.remove('active');
    });
});



new KrealabModal();

jQuery(function($){
    new KrealabAjaxForm($);
});



document.addEventListener('DOMContentLoaded', function () {
    console.log('DOM fully loaded and parsed');

    const buttonsContainer = document.getElementById('sticky-buttons');
    if (!buttonsContainer) {
        console.log("Buttons container not found");
        return;
    }
    console.log("Buttons container found:", buttonsContainer);

    const buttons = buttonsContainer.querySelectorAll('.fl-button-wrap a');
    if (!buttons.length) {
        console.log("Buttons not found");
        // On continue quand même pour la logique sticky
    } else {
        console.log("Buttons found:", buttons);
    }

    function checkSticky() {
        const stickyClass = 'desktop-sticky';
        const rect = buttonsContainer.getBoundingClientRect();
        console.log('Rect top:', rect.top);

        if (rect.top <= 32) { // Ajuste ici si nécessaire
            buttonsContainer.classList.add(stickyClass);
            console.log('Class added');
        } else {
            buttonsContainer.classList.remove(stickyClass);
            console.log('Class removed');
        }
    }

    checkSticky(); // Vérifie la sticky au chargement
    window.addEventListener('scroll', () => {
        console.log('Scrolling...');
        checkSticky();
    });

    // Ajouter un événement de clic pour faire défiler vers la section correspondante si des sections existent
    if (buttons.length) {
        buttons.forEach(button => {
            button.addEventListener('click', function(event) {
                event.preventDefault();
                const target = document.querySelector(button.getAttribute('href'));
                if (target) {
                    window.scrollTo({
                        top: target.offsetTop,
                        behavior: 'smooth'
                    });
                }
            });
        });
    }
});




// //QUOTE TESTIMONIALS
// document.addEventListener("DOMContentLoaded", function() {
//     const testimonials = document.querySelectorAll('.testimonial-quote');

//     testimonials.forEach(function(quote) {
//         let content = quote.innerHTML.trim();

//         // Ajout des guillemets autour du texte
//         quote.innerHTML = `<span class="quote-before">“</span>${content}<span class="quote-after">”</span>`;
//     });
// });

document.addEventListener("DOMContentLoaded", function () {
    const tabButtons = document.querySelectorAll(".tab-button");
    const tabPanes = document.querySelectorAll(".tab-pane");

    // Loguer les éléments pour vérifier qu'ils sont bien sélectionnés
    console.log(tabButtons, tabPanes);

    // Fonction pour activer un onglet spécifique
    function activateTab(tabId) {
        tabButtons.forEach(btn => btn.classList.remove("active"));
        tabPanes.forEach(pane => pane.classList.remove("active"));

        const buttonToActivate = document.querySelector(`[data-tab="${tabId}"]`);
        const paneToActivate = document.getElementById(tabId);

        if (buttonToActivate && paneToActivate) {
            buttonToActivate.classList.add("active");
            paneToActivate.classList.add("active");
        }
    }

    // Gestionnaires d'événements pour les boutons de tabulation
    tabButtons?.forEach(button => {
        button.addEventListener("click", function () {
            const tabId = button.getAttribute("data-tab");
            activateTab(tabId);
        });
    });

    // Gestionnaires d'événements pour les boutons externes
    document.getElementById("ref-presta").addEventListener("click", function (e) {
        // e.preventDefault(); // Empêche le comportement par défaut de l'ancre
        activateTab("tab-174"); // Activer l'onglet PrestaShop (tab-174)
    });

    document.getElementById("ref-wordpress").addEventListener("click", function (e) {
        // e.preventDefault(); // Empêche le comportement par défaut de l'ancre
        activateTab("tab-176"); // Activer l'onglet WordPress (tab-176)
    });
});


document.addEventListener("DOMContentLoaded", function(){
    const btnFormationPopup = document.querySelectorAll('.button-active-popup');
    const formationPopup = document.getElementById('formation-popup');
    const closePopupBtn = document.getElementById('close-formation-popup');

    if (btnFormationPopup && formationPopup) {
        btnFormationPopup.forEach(button => {
            button.addEventListener("click", function(e){
                e.preventDefault();
                formationPopup.classList.add('show');
            });
        });

        // Fermer la popup lorsque l'on clique sur la croix
        closePopupBtn.addEventListener("click", function() {
            formationPopup.classList.remove('show');
        });

        // Fermer la popup lorsqu'on clique en dehors de la fenêtre de la popup
        formationPopup.addEventListener("click", function(e) {
            if (e.target === formationPopup) { // Vérifie si le clic est en dehors de la formation-form
                formationPopup.classList.remove('show');
            }
        });
    }
});

